import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/session/password-reset')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className="outline-brand-100/70 flex w-full max-w-[328px] flex-col gap-6 rounded-md bg-white p-4 shadow-lg outline-8">
      <Outlet />
    </div>
  )
}
